import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle,
} from "react-beautiful-dnd";
import styled from "styled-components";
import { ImageData } from "../../utils/image/image-data";
import { DraggableSmallLocationImagePreviewCard } from "../draggable-list/DraggableSmallLocationImagePreviewCard";

interface Props {
  dialogImageData: ImageData[];
  setImageData: React.Dispatch<React.SetStateAction<ImageData[]>>;
  selectedImage?: ImageData;
  setSelectedImage: React.Dispatch<React.SetStateAction<ImageData | undefined>>;
}

type DraggableStyle = DraggingStyle | NotDraggingStyle | undefined;

export const DraggableSmallLocationImagePreview: React.FC<Props> = ({
  dialogImageData,
  setImageData,
  selectedImage,
  setSelectedImage,
}) => {
  const handleClickRemoveButton = (url: string) => {
    setImageData(dialogImageData.filter((data) => data.url !== url));
  };

  const reOrder = (list: ImageData[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [deleted] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, deleted);
    setSelectedImage(list[startIndex]);

    return result;
  };

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return;
    }

    const newFiles = reOrder(
      dialogImageData,
      result.source.index,
      result.destination.index
    );

    setImageData(newFiles);
  };

  const getListStyle = (isDraggingOver: boolean) => ({
    display: "flex",
    marginTop: "1rem",
    width: "598px",
  });

  return (
    <DraggableSmallLocationImagePreviewContainer>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId="location-image-droppable"
          direction="horizontal"
        >
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {dialogImageData.map((data, index) => (
                <Draggable
                  key={index}
                  draggableId={`location-image-draggable-${index}`}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      onClick={() => setSelectedImage(data)}
                    >
                      <DraggableSmallLocationImagePreviewCard
                        dialogImageData={data}
                        index={index}
                        isDragging={snapshot.isDragging}
                        isSelected={data.url === selectedImage?.url}
                        handleClickRemoveButton={handleClickRemoveButton}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </DraggableSmallLocationImagePreviewContainer>
  );
};

const DraggableSmallLocationImagePreviewContainer = styled.div`
  overflow-x: auto;
`;
